import { motion } from "framer-motion";
import { Check, Loader2, Mail } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { GuaranteeBadge } from "./GuaranteeBadge";

export const DirectoryUpsell = ({ onBuy, price, loading }) => {
  const { content } = useContent();
  const a = content.addon || {};
  const bullets = a.bullets || [];

  return (
    <section id="directory" className="relative py-20 lg:py-28 bg-[#0a0a0a] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-10 lg:gap-16 items-center">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-accent">// Add-On · Standalone</span>
            <h2 className="mt-5 font-display font-black uppercase tracking-tighter text-3xl sm:text-5xl leading-[0.9]">{a.heading}</h2>
            <div className="mt-5 flex items-baseline gap-3">
              <span data-testid="directory-price-inline" className="font-display font-black text-4xl text-accent">{price || "$9"}</span>
              <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/40">one-time · no subscription</span>
            </div>
            <p className="mt-6 font-body text-white/55 leading-relaxed max-w-xl">{a.desc}</p>
            <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3">
              {bullets.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <Check size={15} className="text-accent mt-0.5 flex-shrink-0" strokeWidth={3} />
                  <span className="font-body text-sm text-white/70">{b}</span>
                </li>
              ))}
            </ul>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="border border-white/10 bg-[#050505] p-8 lg:p-10"
          >
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">{a.name}</p>
            <div className="mt-4 flex items-baseline gap-3">
              <span data-testid="directory-price" className="font-display font-black text-5xl">{price || "$9"}</span>
              <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/40">one-time</span>
            </div>
            <div className="mt-4 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.15em] text-white/40">
              <Mail size={13} className="text-accent" /> Instant email delivery
            </div>
            <button
              data-testid="directory-buy-button"
              onClick={onBuy}
              disabled={loading}
              className="group relative mt-8 w-full inline-flex items-center justify-center gap-3 bg-accent text-white font-mono uppercase tracking-[0.15em] text-sm px-8 py-4 overflow-hidden disabled:opacity-70"
            >
              <span className="absolute inset-0 bg-white translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]" />
              <span className="relative z-10 flex items-center gap-2 group-hover:text-black transition-colors duration-300">
                {loading ? <><Loader2 size={16} className="animate-spin" /> Opening checkout…</> : "Get The Directory"}
              </span>
            </button>
            <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.15em] text-white/30 text-center">Or get it all in the full pack above</p>
            <div className="mt-5 flex justify-center"><GuaranteeBadge /></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
